import React, { useCallback } from "react";
import { Phone } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";

import _CallDispositionModal from "routes/call_dispositions/components/CallDispositionModal";
import CallDispositionService from "services/CallDispositions";
import {
  invalidateCallDispositionsQuery,
  useCallDispositionsTable,
} from "hooks/useCallDispositionsTable";

export const CALL_DISPOSITIONS_TABLE_CONSTANTS = {
  tableName: "call_dispositions",
  queryKey: "call-dispositions",
  exportTableName: "CallDispositionsTable",
  className: "CallDisposition",
  header: "Call Dispositions",
  headerIcon: Phone,
};

const CallDispositionModal = withRoleCheck(_CallDispositionModal, [
  ACL_RELATIONSHIPS.disposition.create,
]);

const CallDispositionsTableV3 = () => {
  const { columns, parentDispositions } = useCallDispositionsTable();

  const fetchCallDispositions = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await CallDispositionService.getDispositions(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching call dispositions:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={CALL_DISPOSITIONS_TABLE_CONSTANTS.headerIcon}
      header={CALL_DISPOSITIONS_TABLE_CONSTANTS.header}
      queryKey={CALL_DISPOSITIONS_TABLE_CONSTANTS.queryKey}
      exportTableName={CALL_DISPOSITIONS_TABLE_CONSTANTS.exportTableName}
      tableName={CALL_DISPOSITIONS_TABLE_CONSTANTS.tableName}
      className={CALL_DISPOSITIONS_TABLE_CONSTANTS.className}
      createButton={
        <CallDispositionModal
          onSuccess={invalidateCallDispositionsQuery}
          parentDispositions={parentDispositions}
        />
      }
      fetchData={fetchCallDispositions}
      invalidateData={invalidateCallDispositionsQuery}
      enableSettings
      enableSearch
    />
  );
};

export default CallDispositionsTableV3;
